import {Controller} from "stimulus"
import GoogleMapController from "./google_map_controller"
import EventEmitter from "../utils/EventEmitter"
import MarkerClusterer from "@google/markerclustererplus"
import DOMUtils from "../utils/DOMUtils"
import defaultMapStyle from "../utils/defaultMapStyle.js"

export default class extends GoogleMapController {

    static targets = [
        "map",
        "panel",
        "panelItemsList",
        "close"
    ]

    initialize() {

        super.initialize()

        EventEmitter.on(`googleMapCreated${this.id}`, e => {

            this.mapBounds = new this.googleMap.google.maps.LatLngBounds()

            this.makeMarkers()
            this.makeCluster()

        })
    }

    makeMarkers() {

        const w = 20
        const h = 20

        let markers = this.posts.map(el => {
            return el.posts.map(subEl => {
                const icon = {
                    url: subEl.icon, // url
                    scaledSize: new this.googleMap.google.maps.Size(w, h), // scaled size
                    origin: new this.googleMap.google.maps.Point(0, 0), // origin
                    anchor: new this.googleMap.google.maps.Point(w / 2, h) // anchor
                }

                return {
                    ...subEl,
                    coords: {lat: parseFloat(subEl.coords.lat), lng: parseFloat(subEl.coords.lng)},
                    icon,
                }
            })
        }).flat()

        this.googleMap.setMarkers(markers)

        this.googleMap.makeMarkers()

    }

    makeLines() {

        if (this.posts) {

            this.posts.forEach(item => {

                const coords = item.posts.map(el => {
                    return {
                        lat: parseFloat(el.coords.lat),
                        lng: parseFloat(el.coords.lng),
                    }
                })

                const flightPath = new this.googleMap.google.maps.Polyline({
                    path: coords,
                    geodesic: true,
                    strokeColor: item.road.color ? item.road.color : '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 4
                })

                flightPath.setMap(this.googleMap.map)

            })

        }

    }

    makeCluster() {

        /**
         * Add a marker clusterer to manage the markers.
         */
        const markerClusterStyle = {
            textColor: '#fff',
            height: 30,
            textSize: 14,
            width: 30,
            url: `${urls.assets}/img/m-1.png`,
        }

        this.makerCluster = new MarkerClusterer(this.googleMap.map, this.googleMap.markers, {
            imagePath: `${urls.assets}/img/gmap-cluster/m-`,
            maxZoom: 15,
            minimumClusterSize: 1,
            zoomOnClick: true,
            styles: [
                markerClusterStyle,
                markerClusterStyle,
                markerClusterStyle,
                markerClusterStyle,
                markerClusterStyle
            ]
        })

        this.googleMap.google.maps.event.addListener(this.makerCluster, 'click', (e) => {
            let numberOfMarkers = e.markers_.length;

            if (numberOfMarkers === 1) {
                let marker = e.markers_[0]
                let title = marker["title"]
                let divs = document.querySelectorAll("div")

                divs.forEach(element => {
                    element.classList.remove('is-active')
                    let name = element.getAttribute("title")
                    if (name === title) {
                        element.classList.add('is-active')
                    }
                })

                let sidePannel = "side-pannel-" + marker.id
                let sidePannelElement = document.getElementsByClassName(sidePannel)[0]

                let activePannel = document.getElementsByClassName('side-pannel is-active')[0]

                if (activePannel) {
                    activePannel.classList.toggle("is-active")
                }

                sidePannelElement.classList.toggle("is-active")
                e.preventDefault();

            } else {
                let cluster = e
                console.log(cluster)

            }

        })

    }

    replaceCardsInDOM(markers) {

    }

    getCardHTML(data) {
        console.log(data);

        return `
            <div class="map-panel__el">
                <a href="${data.road.url}" class="map-panel__item road road_small u-mar-b-20" style="border-top: 3px solid ${data.road.color}; border-bottom: 3px solid ${data.road.color};"><span style="color: ${data.road.color};">${data.road.title}</span></a>
                <a href="${data.url}" class="map-panel__item surrounded surrounded_big u-mar-b-20">${data.title}</a>
                <a href="${data.institut.url}" class="map-panel__item island island-small u-mar-b-20">${data.institut.title}</a>
                <a href="${data.url}" class="map-panel__item blue-img">${data.image ? `<img src="${data.image}">` : ''}</a>
            </div>
        `

    }

    closePanel() {
        this.element.classList.remove("is-opened")
        document.body.classList.remove("is-opened")
    }

    openPanel() {
        this.element.classList.add("is-opened")
        document.body.classList.add("is-opened")
    }

    close() {
        console.log("coucou")
    }

    get posts() {
        let data = this.data.get("posts")
        return data && data !== "" ? JSON.parse(data) : false
    }

    get options() {
        return {
            makeCenterMarker: false,
            withCustomStyle: true,
            mapDiv: this.mapTarget,
            onMarkersLoop: marker => {
                this.googleMap.addMarker({lat: marker.coords.lat, lng: marker.coords.lng}, marker)
                this.mapBounds.extend(marker.coords)
            },
            callbackMarkerClick: marker => {
                let title = marker["title"]
                let divs = document.querySelectorAll("div")

                divs.forEach(element => {
                    element.classList.remove('is-active')
                    let name = element.getAttribute("title")
                    if (name === title) {
                        element.classList.add('is-active')
                    }
                })

                let sidePannel = "side-pannel-" + marker.id
                let sidePannelElement = document.getElementsByClassName(sidePannel)[0]

                let activePannel = document.getElementsByClassName('side-pannel is-active')[0]

                if (activePannel) {
                    activePannel.classList.toggle("is-active")
                }

                sidePannelElement.classList.toggle("is-active")


            },
            centerPosition: {
                lat: 50.5,
                lng: 4.4
            }
        }


    }

    get googleMapOptions() {
        const zoom = 3.2
        return {
            zoom: 8.3, maxZoom: 20, minZoom: 3.2, zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            mapTypeControlOptions: false,
            gestureHandling: 'greedy',
            scrollwheel: true,
            style: defaultMapStyle
        }
    }


}
